import React, { useState, useEffect } from 'react';
import { ListItem, ListItemContent, Box, Alert } from "@mui/joy";
import { Button } from '../Button';
import { useTranslation } from 'react-i18next'
import { Tag } from '../Snippet'
import { Anchor } from '../Typography';
import { useDataProvider } from 'src/mtska-frontend-data-provider'

const RelationshipSaltEdgeConnection = ({ k, v: data, editing, handleItemDetail, handleItemRemove, loadingDissociation }) => {

    const { created_at, name: initName, saltEdgeCreationUrl: initSaltEdgeCreationUrl, status } = data || {}

    const action = 'refreshUrl'

    const model = 'companies/saltedgeconnection'

    const { doAction, errorMessage } = useDataProvider(model)

    const [newConnection, setNewConnection] = useState()

    const { name: newName, saltEdgeCreationUrl: newSaltEdgeCreationUrl } = newConnection || {}

    const name = newName || initName
    const saltEdgeCreationUrl = newSaltEdgeCreationUrl || initSaltEdgeCreationUrl

    const { t } = useTranslation();

    const tagcolors = {
        active: "success",
        inactive: "warning",
        disabled: "danger"
    }

    const [countdown, setCountdown] = useState();

    useEffect(() => {
        const targetDate = newConnection ? new Date() : new Date(created_at)
        const duration = 60 * 1000;
        const endDate = new Date(targetDate.getTime() + duration);

        const updateCountdown = () => {
            const now = new Date();
            const timeLeft = Math.max(0, Math.floor((endDate - now) / 1000));
            setCountdown(timeLeft);

            if (timeLeft <= 0) {
                clearInterval(timer);
            }
        };

        const timer = setInterval(updateCountdown, 1000);
        updateCountdown(); // Esegui subito il calcolo iniziale

        return () => clearInterval(timer);
    }, [newConnection])

    const getNewConnection = () => {
        doAction({ action, data, model })
            .then((data) => {
                if (data?.item?.data) {
                    setNewConnection(data.item.data)
                } else {
                    console.error('getNewConnection', data?.message)
                }
            })
    }

    return (
        <ListItem key={k} variant="outlined" className={"relationship-element"}>
            <ListItemContent className={"relationship-element-content"}>
                <Box className="name">
                    {name}
                </Box>
                <Box className={"status"}>
                    <Tag color={(tagcolors[status ? status : 'inactive'])} size="small" label={t(status ? status : 'inactive')} />
                </Box>
                {
                    <Box className="connectionlink coupled">
                        {countdown > 0 && <>
                            <Anchor className="label" href={saltEdgeCreationUrl} target='_blank' icon={'faPlug'}>{t('Connection Link')}</Anchor>
                            <Box className="value connectionLinxExpiration">Scade tra {countdown} secondi</Box>
                        </>}
                        {!status && !countdown && <Box display='flex' gap='10px'>
                            <Button icon='faPlug' onClick={getNewConnection} title='Riconnetti' />
                            {errorMessage && <Alert color='danger' size='sm'>{t(errorMessage)}</Alert>}
                        </Box>}
                    </Box>
                }
            </ListItemContent>
            {editing && (<Button onClick={() => handleItemDetail(data)} icon="faPen" variant="plain" />)}
            {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(data)} icon="faClose" variant="plain" />)}
        </ListItem>
    )
}

export default RelationshipSaltEdgeConnection
